'use client';

import { BridgePageContainer } from 'structure/bridge/components/BridgePageContainer/BridgePageContainer';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';

export default function BridgePage() {
  return (
    <BaseLayout>
      <BridgePageContainer />
    </BaseLayout>
  );
}
